<template>
    <div class="mask-from-main">
        <div class="book-now-content" @click="closeEvent">
            <div class="close">
                <img loading="lazy"  src="../../../static/img/newProductDetils/swiperClose.png" alt="" class="close-img">
            </div>
            <div class="book-now-center" @click.stop>
                <div class="title" :class="{'banner-fade-in':fadeIn}">Contact Us</div>
                <el-form :model="userInfo" :rules="rules" ref="form" :class="{'banner-fade-in':fadeIn}">
                    <div class="from">
                        <div class="from-input" @click="$refs.newNameInput.focus()">
                            <div class="left">
                                <div class="left-title"><span style="color: red;">*</span>First Name</div>
                                <el-form-item prop="newName">
                                    <div class="input">
                                        <el-input ref="newNameInput" v-model="userInfo.newName" :maxlength="100"></el-input>
                                    </div>
                                </el-form-item>
                            </div>
                            <!-- <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line1.png" alt=""></div> -->
                        </div>
                        <div class="from-input" @click="$refs.oldNameInput.focus()">
                            <div class="left">
                                <div class="left-title">Last Name</div>
                                <el-form-item prop="oldName">
                                    <div class="input">
                                        <el-input ref="oldNameInput" v-model="userInfo.oldName"></el-input>
                                    </div>
                                </el-form-item>
                            </div>
                            <!-- <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line1.png" alt=""></div> -->
                        </div>
                        <div class="from-input" @click="$refs.emailInput.focus()">
                            <div class="left">
                                <div class="left-title"><span style="color: red;">*</span>Email Address</div>
                                <el-form-item prop="email">
                                    <div class="input">
                                        <el-input ref="emailInput" v-model="userInfo.email" :maxlength="100"></el-input>
                                    </div>
                                </el-form-item>
                            </div>
                            <!-- <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line1.png" alt=""></div> -->
                        </div>
                        <div class="from-input" @click="$refs.phoneInput.focus()">
                            <div class="left">
                                <div class="left-title"><span style="color: red;">*</span>Phone</div>
                                <el-form-item prop="phone">
                                    <div class="input">
                                        <el-input ref="phoneInput" v-model="userInfo.phone" @input="validatePositiveInteger(userInfo.phone,3)" :maxlength="20"></el-input>
                                    </div>
                                </el-form-item>
                            </div>
                            <!-- <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line1.png" alt=""></div> -->
                        </div>
                        <!-- <div class="from-input">
                            <div class="left">
                                <div class="left-title"><span style="color: red;">*</span>Arrival Date</div>
                                <el-form-item prop="arrivalDate">
                                    <div class="input">
                                        <div class="block">
                                            <el-date-picker 
                                            v-model="userInfo.arrivalDate" 
                                            type="date" 
                                            :picker-options="pickerOptions" 
                                            @input="startTimeChange"
                                            ></el-date-picker>
                                        </div>
                                    </div>
                                </el-form-item>
                            </div>
                            <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/from/time.png" alt=""></div>
                        </div> -->
                        <!-- <div class="from-input end-time-input">
                            <div class="left">
                                <div class="left-title"><span style="color: red;">*</span>Departure Date</div>
                                <el-form-item prop="departureDate">
                                    <div class="input">
                                        <div class="block">
                                            <el-date-picker 
                                            v-model="userInfo.departureDate" 
                                            type="date" 
                                            :picker-options="departurePickerOptions" 
                                            :disabled="isInputMask ? true : false"
                                            ></el-date-picker>
                                        </div>
                                    </div>
                                </el-form-item>
                            </div>
                            <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/from/time.png" alt=""></div>
                            <div class="mask" v-show="isInputMask" @click="endTimeClickNoticeEvent"></div>
                        </div> -->
                        <!-- <div class="from-input">
                            <div class="left">
                                <div class="left-title"><span style="color: red;">*</span>Adults</div>
                                <el-form-item prop="adults">
                                    <div class="input">
                                        <el-input 
                                        :maxlength="3"
                                        v-model="userInfo.adults" 
                                        @input="validatePositiveInteger(userInfo.adults,1)"></el-input>
                                    </div>
                                </el-form-item>
                            </div>
                            <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line2.png" alt=""></div>
                        </div>
                        <div class="from-input">
                            <div class="left">
                                <div class="left-title"><span style="color: red;">*</span>Children (≤13)</div>
                                <el-form-item prop="child">
                                    <div class="input">
                                        <el-input 
                                        :maxlength="3" 
                                        v-model="userInfo.child" 
                                        @input="validatePositiveInteger(userInfo.child,2)"></el-input>
                                    </div>
                                </el-form-item>
                            </div>
                            <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line2.png" alt=""></div>
                        </div> -->
                    </div>
                     <div class="choose">
                        <div class="text">
                            Would you like to be contacted by a travel consultant?<span style="color: red;">*</span>
                        </div>
                        <div class="radio">
                            <div class="radio-item" v-for="item in radioList" :key="item.id">
                                <div class="img" :class="{'notActive':userInfo.radio != item.id}" @click="radioClickEvent(item.id)"><img loading="lazy"  v-show="userInfo.radio == item.id" src="../../../static/img/bookNow/from/Checklist.png" alt=""></div>
                                <div class="info">{{item.info}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="textarea">
                        <div class="textarea-title">Message the host</div>
                        <el-form-item prop="message">
                            <el-input
                                type="textarea"
                                :rows="2"
                                placeholder="Tell us more about your trip, such as your desired destination, budget per person per day, etc…"
                                v-model="userInfo.message"
                                maxlength="800"
                                show-word-limit
                            >
                            </el-input>
                        </el-form-item>
                    </div>
                    <el-form-item>
                        <div class="submit" @click="submitForm">submit</div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
// import {startTimeChangeWay,startTimeRulesEvent,endTimeRulesEvent} from '/js/fromRules/fromRulesWay.js';
import rulesDetials from '/js/fromRules/rulesDetials.js';
export default {
    data(){
        return {
            userInfo: {
                newName: '',
                oldName: '',
                email: '',
                phone: '',
                // arrivalDate: '',
                // departureDate: '',
                // adults: '',
                // child: '',
                message: '',
                radio: '1'
            },
            rules:rulesDetials.rules,
             radioList:[
                {
                    id:1,
                    info:'Yes'
                },
                {
                    id:2,
                    info:'No'
                }
            ],
            fadeIn:false
            // pickerOptions: {
            //     disabledDate(time) {
            //         return startTimeRulesEvent(time)
            //     }
            // },
            // isInputMask:true,
        }
    },
    mounted(){
        this.fadeIn = true
    },
     // 结束时间限制
    //  computed: {
    //     departurePickerOptions() {
    //         return {
    //             disabledDate: (time) => {
    //                 return endTimeRulesEvent(this.userInfo.arrivalDate,time)

    //             }
    //         };
    //     }
    // },
    methods: {
            // 验证人数
        validatePositiveInteger(value,id) {
            if (/^[1-9]\d*$/.test(value)) {
                // 如果是正整数
                if (id === 1) {
                    this.userInfo.adults = value;
                }
                //  else if (id === 2) {
                //     this.userInfo.child = value;
                // } else if (id === 3) {
                //     this.userInfo.phone = value;
                // }
            } else {
                // 如果不是正整数，清空相应的字段
                if (id === 1) {
                    this.userInfo.adults = '';
                } 
                // else if (id === 2) {
                //     this.userInfo.child = '';
                // } else if (id === 3) {
                //     this.userInfo.phone = '';
                // }
            }
        },
        // 判断是否输入开始时间
        // startTimeChange() {
        //     this.isInputMask = startTimeChangeWay(this.userInfo.arrivalDate)
        // },
        // // 先选结束时间进行提示
        // endTimeClickNoticeEvent(){
        //     this.$message({
        //         message: 'Please select the arrival date',
        //         type: 'warning'
        //     });
        // },
        closeEvent(){
            this.$emit('closeFatherEvent',false)
        },
        // 提交表单
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if(this.userInfo.phone.length < 3){
                        this.$message({
                            message: 'Please enter a valid phone number',
                            type: 'warning'
                        });
                        return
                    }else{
                        this.$axios.post('/submit', this.userInfo)
                        .then(response => {
                            this.$message({
                                message:response.message,
                                type: 'success'
                            });
                            this.$emit('closeFatherEvent',false)
                        })
                        .catch(error => {
                            this.$message.error(error.message) // 处理错误
                        });
                    }
                    
                } else {
                    this.$message({
                        message: 'Please fill in all required fields and ensure that the input is correct',
                        type: 'warning'
                    });
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@import '/style/pc/common/radio.scss';
@import '/style/pc/common/fadeIn.scss';
::v-deep .el-input__inner {
    width: 25rem;
    border: none;
    background-color: #F2F4F6 !important;
    color: #242527;
    font-family: Inter;
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    padding: 0 !important;
    height: 2rem;
}
::v-deep .el-textarea__inner {
    height: 6.25rem;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}
::v-deep .el-form-item__content {
    margin-left: 0 !important;
    line-height: 1.5rem;
}
::v-deep .el-form-item__error {
    top: 2.5rem !important;
    font-family: Inter;
    font-size: 0.75rem !important;
}
::v-deep .el-form-item {
    margin-bottom: 0 !important;
}
 ::v-deep .el-textarea__inner {
    color: #7D7C84;
    font-family: Inter;
    font-size: 1rem;
    font-weight: 300;
}
::v-deep .el-input__prefix {
    display: none;
}
::v-deep .el-button {
    display: flex;
    width: 9.25rem;
    height: 3.1875rem;
    justify-content: center;
    align-items: center;
    border-radius: 5.625rem !important;
    color: #FFF;
    font-size: 1rem;
    font-weight: 700;
}
.close{
    display: flex;
    justify-content: flex-end;
    width: 65rem;
}
.close-img{
    width: 1.625rem;
    height: 1.625rem;
    margin-bottom: 1.4375rem;
}
// 表单
.book-now-content {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .book-now-center {
        border-radius: 0.25rem;
        width: 60rem;
        // height: 654px;
        background: #fff;
        padding: 2.5rem;
        .title {
            font-weight: 700;
            font-size: 2rem;
            color: #242527;
            margin-bottom: 1.875rem;
            font-family: Butler;
        }
        .from {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .from-input {
                width: 27rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0.5rem 1rem;
                border-radius: 0.125rem;
                background-color: #F2F4F6;
                margin-bottom: 1.5rem;
                .left-title{
                    font-family: Inter;
                    font-size: 0.875rem;
                    color: #7D7C84;
                }
            }
            .from-input:nth-child(7),.from-input:nth-child(8){
                margin-bottom: 1.25rem;
            }
            img {
                width: 1.25rem;
                height: 1.25rem;
            }
            .submit {
                margin-top: 2rem;
                margin-bottom: 5.625rem;
            }
            }
            .textarea {
                // height: 11.25rem;
                margin-bottom: 1.25rem;
                .textarea-title {
                    margin-bottom: 0.75rem;
                    color:  #09080D;
                    font-size: 1.25rem;
                    font-style: normal;
                    font-weight: 500;
                    font-family: Butler;
                }
            }
            .end-time-input{
                position: relative;
            }
            .submit {
                display: flex;
                width: 13.875rem;
                height: 4.375rem;
                justify-content: center;
                align-items: center;
                border-radius: 0.125rem;
                background: #061A31;
                color: #FFF;
                font-family: Inter;
                font-size: 1.25rem;
                font-weight: 600;
                cursor: pointer;
                border-radius: 0.125rem;
                margin: 0 auto;
            }
            .submit:hover{
                background: #162A41;;
            }
        }
        .mask{
            position: absolute;
            width:100%;
            left: 0;
            top: 0;
            height: 100%;
            z-index: 1;
        }
    }
</style>